<template>
    <common-modal
        height="medium"
        width="extra-large"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <div class="content">
            <common-loader v-if="isLoading"></common-loader>
            <p v-else-if="loadError" class="content__error">{{ $t('common.errors.load_failed') }}</p>
            <div v-else-if="usePhysicianLayout" class="providers-list">
                <div v-for="(item, index) in providers" :key="itemKey(item, index)" class="providers-list__item">
                    <external-recipient-card v-if="item.type === 'external'" :recipient="item"></external-recipient-card>
                    <practice-member-card
                        v-else
                        :physician="item"
                        :showNetworkInclusionStatus="false"
                        :showMasterUserAuthorities="false"
                        :showCardAvailability="false"
                        :showMatchStatus="true"
                    ></practice-member-card>
                </div>
            </div>
            <div v-else class="providers-list">
                <ancillary-member-card
                    v-for="(item, idx) in providers"
                    :key="item.id != null ? item.id : `anc-${idx}`"
                    :ancillary="item"
                    :showCardAvailability="false"
                    :showMatchStatus="true"
                ></ancillary-member-card>
            </div>
        </div>
    </common-modal>
</template>

<script>
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import PracticeMemberCard from 'components/page-elements/practice/PracticeMemberCard'
    import AncillaryMemberCard from 'components/page-elements/practice/AncillaryMemberCard'
    import ExternalRecipientCard from 'components/page-elements/practice/ExternalRecipientCard'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            PracticeMemberCard,
            AncillaryMemberCard,
            ExternalRecipientCard,
        },
        props: {
            referralPoolId: { type: Number, required: true },
        },
        data() {
            return {
                providers: [],
                isLoading: true,
                loadError: null,
                PracticeTypeEnum,
            }
        },

        computed: {
            usePhysicianLayout() {
                if (!this.providers.length) return false
                const first = this.providers[0]
                if (first.type === 'external') return true
                return first.practice?.practiceType === PracticeTypeEnum.PHYSICIAN
            },
        },

        methods: {
            itemKey(item, index) {
                if (item.type === 'external') return `ext-${item.providerNpi || item.id || index}`
                return item.id != null ? item.id : `in-pool-${index}`
            },
            getReferralPoolProviders() {
                this.isLoading = true
                this.loadError = null
                ReferralsPoolAPI.getReferralsPoolProviders(this.referralPoolId, {
                    feasibility: true,
                })
                    .then((response) => {
                        this.providers = Array.isArray(response) ? response : Array.isArray(response?.data) ? response.data : []
                    })
                    .catch(() => {
                        this.loadError = true
                        this.providers = []
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        mounted() {
            this.getReferralPoolProviders()
        },
    }
</script>

<style scoped lang="scss">
    .content {
        max-height: 500px;
        overflow-y: auto;

        &__error {
            padding: 20px;
            text-align: center;
            color: var(--color-error, #c00);
        }
    }

    .providers-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 10px 10px;
        overflow-x: hidden;

        &__item {
            min-width: 0;
        }
    }
</style>
